import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-descripted-toggle-section',
  templateUrl: './descripted-toggle-section.component.html',
  styleUrls: ['./descripted-toggle-section.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DescriptedToggleSectionComponent,
    },
  ],
})
export class DescriptedToggleSectionComponent implements ControlValueAccessor {
  @Input() public titleLabel: string;
  @Input() public description: string;
  @Input() public value = false;
  @Input() public editable = true;

  public valueChangedFromOutside$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private _touched = false;
  private _disabled = false;

  public writeValue(value: boolean): void {
    this.value = value;
    this.valueChangedFromOutside$.next(value);
  }

  public registerOnChange(onChange: (value: boolean) => void): void {
    this._onChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this._onTouched = onTouched;
  }

  public markAsTouched() {
    if (!this._touched) {
      this._onTouched();
      this._touched = true;
    }
  }

  public setDisabledState(disabled: boolean) {
    this._disabled = disabled;
  }

  public onClick(value: boolean) {
    this.markAsTouched();
    if (!this._disabled) {
      this.value = value;
      this._onChange(this.value);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private _onChange = (value: boolean) => {};

  private _onTouched = () => {};
}
